import { useEffect } from "react";
import { UserI } from "@/types/base";
import { syncDcUser } from "@/api/user";

type UseDcSyncUserOptions = {
  user: UserI | null;
  onSync: (updatedFields: Partial<UserI>) => void;
};

export const useDcSyncUser = ({ user, onSync }: UseDcSyncUserOptions) => {
  useEffect(() => {
    if (!user?.telegram_id) return;

    const runSync = async () => {
      try {
        const { updated_fields } = await syncDcUser();
        if (!Object.keys(updated_fields).length) return;

        onSync(updated_fields);
      } catch (error) {
        console.error("Failed to sync user data:", error);
      }
    };

    runSync();
  }, [user?.telegram_id]);
};
